<div class="side-sheet-container container">
    <ng-content select=".hierarchy-main-controller"></ng-content>
    <div class="anchor-element">
        <div
            #editHierarchyDialog
            [hidden]="isEditDialogClose"
            class="hierarchy-edit-container-main"
        >
            <mat-menu-surface class="hierarchy-edit-container">
                <div class="menu-surface-area">
                    <h1 mat-dialog-title class="side-sheet-title">{{ sideSheetTitle }}</h1>
                    <ng-content select=".hierarchy-edit-controller"></ng-content>
                    <div class="edit-dialog-button-set">
                        <div class="delete-icon-button">
                            <div [hidden]="isDeleteButtonHidden">
                                <mat-icon
                                    class="delete-icon"
                                    fontSet="fas"
                                    fontIcon="fa-trash-alt"
                                    aria-hidden="true"
                                    (click)="sideSheetDeleteClicked()"
                                >
                                </mat-icon>
                            </div>
                        </div>
                        <div class="button-sets">
                            <button
                                mat-button
                                class="cancel-button"
                                (click)="sideSheetCancelClicked()"
                            >
                                CANCEL
                            </button>
                            <button
                                mat-button
                                class="save-button"
                                [disabled]="isSideSheetSaveBtnDisabled"
                                (click)="sideSheetSaveClicked()"
                            >
                                SAVE
                            </button>
                        </div>
                    </div>
                </div>
            </mat-menu-surface>
        </div>
    </div>
    <div *ngIf="!isMainButtonSetHidden" class="align-bottom-main">
        <div class="button-sets">
            <button mat-button class="cancel-button" (click)="mainCancelClicked()">CANCEL</button>
            <button
                mat-button
                class="save-button"
                [disabled]="isMainSaveBtnDisabled"
                (click)="mainSaveClicked()"
            >
                SAVE
            </button>
        </div>
    </div>
    <!--</mat-card>-->
</div>
